import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ThumbnailImageBody } from './thumbnailImageBody';


export const StoryThumbnail = memo(({ storyImageUrl, hasVideoLinkUrl }) => {

    return (
         <Container>
            <ThumbnailImageBody storyImageUrl={storyImageUrl} hasVideoLinkUrl={hasVideoLinkUrl} />
        </Container>
    );
});

StoryThumbnail.displayName = 'StoryThumbnail';

StoryThumbnail.propTypes = {
    storyImageUrl: PropTypes.string,
    hasVideoLinkUrl: PropTypes.string
};

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
`;
